import DialInsPopover from './DialInsPopover';

export default DialInsPopover;
